var React = require('react');

function ArrowTailed (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.4506 8.18753L11 14.6382L12.7368 16.375L20.9243 8.18753L12.7368 5.14984e-05L11 1.73689L17.4506 8.18753Z","fill":"black","key":0}),React.createElement("path",{"d":"M18.5263 9.34543L-9.53674e-06 9.34543V7.02964L18.5263 7.02964V9.34543Z","fill":"black","key":1})]);
}

ArrowTailed.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = ArrowTailed;

ArrowTailed.default = ArrowTailed;
